module.exports = __webpack_public_path__ + "ic-circle-plus-sign.svg?27008103493c014c1f23541bea7ddbf2";